type DataQuality = {
    value: DataQualityInfo
    labelKey: string
    infoKey: string
}

type QualityAssurance = {
    value: QualityAssuranceInfo
    labelKey: string
    infoKey: string
}

type Justification = {
    value: JustificationInfo
    labelKey: string
    infoKey: string
    groupKey: string
}

export enum DataQualityInfo {
    MeasurementsAnalyses = 'measurements_analyses',
    MeasurementsNational = 'measurements_national',
    MeasurementsSector = 'measurements_sector',
    MeasurementsInternational = 'measurements_international',
    DefaultValuesEC = 'default_values_ec'
}
  
export enum QualityAssuranceInfo {
    ThirdPartyVerification = 'third_party_verification',
    InternalAudits = 'internal_audits',
    FourEyesPrinciple = 'four_eyes_principle',
    None = 'none'
}

export enum JustificationInfo {
    HighCostofTracingEmissions = 'high_cost_of_tracing_emissions',
    DisaggregatingMixedInputs = 'disaggregating_mixed_inputs',
    LackofEmissionData = 'lack_of_emission_data',
    NonCoorparationPrecursorProducer = 'non_coorparation_precursor_producer',
    AbsenceofRecords = 'absence_of_records',
}

export const dataQualityOptions: DataQuality[] = [
    {
      value: DataQualityInfo.MeasurementsAnalyses,
      labelKey: 'reports:finalizedReports.dataQualityOptions.measurementsAnalyses.label',
      infoKey: 'reports:finalizedReports.dataQualityOptions.measurementsAnalyses.info'
    },
    {
      value: DataQualityInfo.MeasurementsNational,
      labelKey: 'reports:finalizedReports.dataQualityOptions.measurementsNational.label',
      infoKey: 'reports:finalizedReports.dataQualityOptions.measurementsNational.info'
    },
    {
      value: DataQualityInfo.MeasurementsSector,
      labelKey: 'reports:finalizedReports.dataQualityOptions.measurementsSectorSpecific.label',
      infoKey: 'reports:finalizedReports.dataQualityOptions.measurementsSectorSpecific.info'
    },
    {
      value: DataQualityInfo.MeasurementsInternational,
      labelKey: 'reports:finalizedReports.dataQualityOptions.measurementsInternational.label',
      infoKey: 'reports:finalizedReports.dataQualityOptions.measurementsInternational.info'
    },
    {
      value: DataQualityInfo.DefaultValuesEC,
      labelKey: 'reports:finalizedReports.dataQualityOptions.defaultValuesEC.label',
      infoKey: 'reports:finalizedReports.dataQualityOptions.defaultValuesEC.info'
    }
  ]

export  const qualityAssuranceOptions: QualityAssurance[] = [
    {
      value: QualityAssuranceInfo.ThirdPartyVerification,
      labelKey: 'reports:finalizedReports.qualityAssuranceOptions.thirdPartyVerification.label',
      infoKey: 'reports:finalizedReports.qualityAssuranceOptions.thirdPartyVerification.info'
    },
    {
      value: QualityAssuranceInfo.InternalAudits,
      labelKey: 'reports:finalizedReports.qualityAssuranceOptions.internalAudits.label',
      infoKey: 'reports:finalizedReports.qualityAssuranceOptions.internalAudits.info'
    },
    {
      value: QualityAssuranceInfo.FourEyesPrinciple,
      labelKey: 'reports:finalizedReports.qualityAssuranceOptions.fourEyesPrinciple.label',
      infoKey: 'reports:finalizedReports.qualityAssuranceOptions.fourEyesPrinciple.info'
    },
    {
      value: QualityAssuranceInfo.None,
      labelKey: 'reports:finalizedReports.qualityAssuranceOptions.none.label',
      infoKey: 'reports:finalizedReports.qualityAssuranceOptions.none.info'
    }
  ]


  export const justificationOptions: Justification[] = [
    {
      value: JustificationInfo.HighCostofTracingEmissions,
      labelKey: 'reports:finalizedReports.justificationOptions.highCostofTracingEmissions.label',
      infoKey: 'reports:finalizedReports.justificationOptions.highCostofTracingEmissions.info',
      groupKey: 'reports:finalizedReports.justificationOptions.firstGroup.groupKey'
    },
    {
      value: JustificationInfo.DisaggregatingMixedInputs,
      labelKey: 'reports:finalizedReports.justificationOptions.disaggregatingMixedInputs.label',
      infoKey: 'reports:finalizedReports.justificationOptions.disaggregatingMixedInputs.info',
      groupKey: 'reports:finalizedReports.justificationOptions.firstGroup.groupKey'
    },
    {
      value: JustificationInfo.LackofEmissionData,
      labelKey: 'reports:finalizedReports.justificationOptions.lackofEmissionData.label',
      infoKey: 'reports:finalizedReports.justificationOptions.lackofEmissionData.info',
      groupKey: 'reports:finalizedReports.justificationOptions.secondGroup.groupKey'
    },
    {
      value: JustificationInfo.NonCoorparationPrecursorProducer,
      labelKey: 'reports:finalizedReports.justificationOptions.nonCoorparationPrecursorProducer.label',
      infoKey: 'reports:finalizedReports.justificationOptions.nonCoorparationPrecursorProducer.info',
      groupKey: 'reports:finalizedReports.justificationOptions.secondGroup.groupKey'
    },
    {
      value: JustificationInfo.AbsenceofRecords,
      labelKey: 'reports:finalizedReports.justificationOptions.absenceofRecords.label',
      infoKey: 'reports:finalizedReports.justificationOptions.absenceofRecords.info',
      groupKey: 'reports:finalizedReports.justificationOptions.secondGroup.groupKey'
    }
  ]